// extracted by mini-css-extract-plugin
export var cards = "Showcases-module--cards--5e7fc";
export var container = "Showcases-module--container--2a795";
export var section = "Showcases-module--section--252cc";
export var trustedSection = "Showcases-module--trustedSection--8ae90";